import MassActivateCardsForm from './MassActivateCardsForm';

export default MassActivateCardsForm;
